import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { OtherVersion } from './other-version.model';

@Component({
  selector: 'other-version',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<div>no template defined</div>',
})
export class OtherVersionComponent implements OnInit {
  @Input() versionDoc: OtherVersion;

  @Input() currentVersionUniqueNumber: string;

  constructor() {}

  ngOnInit() {}

  getOtherVersionDisplayMessage(): string {
    if (this.currentVersionUniqueNumber === this.versionDoc.uniqueNumber) {
      return 'Your Selection';
    }
    return 'Display this version';
  }
}
